import { useMutation, useQueryClient } from 'react-query';

import { assetsApi } from 'src/Services/API';
import { UpdateBudgetCapDto } from 'src/Services/API/generated';

interface UseUpdateBudgetCapOptions {
  onSuccess?: () => void;
}

export const useUpdateBudgetCap = (options?: UseUpdateBudgetCapOptions) => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ assetId, data }: { assetId: string; data: UpdateBudgetCapDto }) =>
      assetsApi.assetsControllerUpdateBudgetCap(assetId, data),
    {
      onSuccess: (_, { assetId }) => {
        queryClient.invalidateQueries(['fetch-asset-details', assetId]);
        queryClient.invalidateQueries(['fetch-expense-stats', assetId]);
        // The home page gauge reads the cap from the dashboard payload, which would otherwise
        // stay stale until a full reload.
        queryClient.invalidateQueries(['fetch-dashboard', assetId]);
        options?.onSuccess?.();
      },
    }
  );
};
